import React, { useState } from "react";
import { useTranslator } from "../../context/translator";

const NewTemplateModal = ({ close, type, onCreate }) => {
  const { translate } = useTranslator();
  const [name, setName] = useState("");

  const create = () => {
    const baseHtml = `<html>
  <body>
    <p>Hello, {{name}}</p>
    <p>This is a new template.</p>
  </body>
</html>`;

    const newT = {
      type,
      name,
      subject: translate("new-template"),
      html: baseHtml,
      text: "",
      newUser: false,
      resetPassword: false,
    };

    onCreate(newT);
  };

  return (
    <div className="fixed inset-0 bg-gray-800 flex items-center justify-center">
      <div className="bg-white dark:bg-gray-900 p-6 rounded-lg w-96">
        <h2 className="text-xl font-semibold mb-3">
          {translate("new-template")}
        </h2>

        <input
          placeholder="Name"
          className="w-full p-2 border rounded-lg dark:bg-gray-800 mb-3"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <div className="flex gap-3 mt-4">
          <button
            className="flex-1 bg-gray-500 text-white p-2 rounded-lg"
            onClick={close}
          >
            {translate("cancel")}
          </button>

          <button
            className="flex-1 bg-green-600 text-white p-2 rounded-lg"
            onClick={create}
          >
            {translate("create")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewTemplateModal;
